import { service } from "@/api/service ";
import { toastError } from "@/components/custom/Toast";
import router from "@/router";
const state = {
  MTNPaymentResult: [],
  MTNTokenGet: {},
};
const getters = {
  MTNResultGet: (state) => state.MTNPaymentResult,
  MTNTokenGetter: (state) => state.MTNTokenGet,
};
const actions = {
  MTNPayment({ commit }, payLoad) {
    service.postFun(payLoad, `user/doPayment`).then(
      (obj) => {
        commit("MTNPayment", obj.data);
      },
      (error) => {
        toastError(error);
      }
    );
  },
  getMtnToken({ commit }, payLoad) {
    service.postFun(payLoad, `user/authenticateMerchant`).then(
      (obj) => {
        var result = obj.data;
        commit("MTNTokenSet", result);
        router.push("/v1/MtnPayment");
      },
      (error) => {
        toastError(error);
      }
    );
  },
};
const mutations = {
  MTNPayment(state, result) {
    state.MTNPaymentResult = result;
  },
  MTNTokenSet(state, result) {
    state.MTNTokenSet = result;
  },
};
export default {
  state,
  getters,
  actions,
  mutations,
};
